<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";

interface Image {
  Url: string;
}

const props = defineProps<{ images: Image[]; height?: number }>();

const swiperHeight = computed(() => (props.height ? props.height : "auto"));
</script>
<template>
  <nut-swiper v-bind="$attrs" :height="swiperHeight">
    <nut-swiper-item v-for="(item, index) in images" :key="index">
      <MpStaticImage
        :src="item.Url"
        width="100%"
        height="100%"
        fit="cover"
        :preview="false"
      />
    </nut-swiper-item>
  </nut-swiper>
</template>
<style lang="scss">
.nut-swiper {
  width: 100%;
}

.nut-swiper-item img {
  width: 100%;
  height: 100%;
}
</style>
